const load = async ({ url }) => {
  let filter = {};
  url.searchParams.forEach((value, key) => {
    if (key.startsWith("filter[")) {
      filter[key] = value;
    }
  });
  return {
    page_title: "Projects",
    status: url.searchParams.get("status"),
    pageSize: url.searchParams.get("pageSize") || 12,
    page: url.searchParams.get("page") || 1,
    sort: url.searchParams.get("sort") || "startsAt",
    search: url.searchParams.get("search") || "",
    order: url.searchParams.get("order") || "desc",
    ...filter
  };
};
export {
  load
};
//# sourceMappingURL=_page.ts.js.map
